<template>
    <div v-if="!actionCreate && isLoading" class="p-6 text-center">
        Cargando…
    </div>

    <template v-if="actionCreate || (!actionCreate && !isLoading && teacher.profile)">
        <div class="w-1/2 pt-2 text-lg pl-1 mb-3">
            <span>
                {{ actionCreate ? 'Agregar Preceptor' : 'Editar Preceptor' }}
            </span>

        </div>

        <form class="bg-gray-100 py-3 rounded-md shadow-md" >
        
            <div  class="grid grid-cols-1 md:grid-cols-3 gap-4 px-3">

                <!-- input firstname -->
                <div>
                    <label class="text-gray-700" for="title">Nombre</label>
                    
                    <input
                        class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
                        type="text" id="title" name="title"
                        v-model="teacher.profile.firstname">

                    <!-- Validacion de frontend -->
                    <span v-if="v$?.teacher?.profile?.firstname && v$.teacher.profile.firstname.$dirty && v$.teacher.profile.firstname.$error" class="text-sm text-red-500 mt-1">
                        <p v-for="error in v$.teacher.profile.firstname.$errors" :key="error.$uid" class="text-sm text-red-500 mt-1 ml-2">
                            {{ error.$message }}
                        </p>
                    </span>
                </div>

                <!-- input lastname -->
                <div>
                    <label class="text-gray-700" for="title">Apellido</label>
                    <span v-if="errors.find( el => el.field == 'lastname')" class="ml-2 text-red-500">
                        * {{ errors.find( el => el.field == 'lastname').message }}
                    </span>
                    
                    <input
                        class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
                        type="text" id="title" name="title"
                        v-model="teacher.profile.lastname">

                    <!-- Validacion de frontend -->
                    <span v-if="v$?.teacher?.profile?.lastname && v$.teacher.profile.lastname.$dirty && v$.teacher.profile.lastname.$error" class="text-sm text-red-500 mt-1">
                        <p v-for="error in v$.teacher.profile.lastname.$errors" :key="error.$uid" class="text-sm text-red-500 mt-1 ml-2">
                            {{ error.$message }}
                        </p>
                    </span>
                </div>

                <!-- input dni -->
                <div >
                    <label class="text-gray-700" for="title">DNI</label>
                    <span v-if="errors.find( el => el.field == 'dni')" class="ml-2 text-red-500">
                        * {{ errors.find( el => el.field == 'dni').message }}
                    </span>
                    
                    <input
                        class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
                        type="text" id="title" name="title"
                        v-model="teacher.profile.dni">

                    <!-- Validacion de frontend -->
                    <span v-if="v$?.teacher?.profile?.cuil && v$.teacher.profile.dni.$dirty && v$.teacher.profile.dni.$error" class="text-sm text-red-500 mt-1">
                        <p v-for="error in v$.teacher.profile.dni.$errors" :key="error.$uid" class="text-sm text-red-500 mt-1 ml-2">
                            {{ error.$message }}
                        </p>
                    </span>

                    <!-- Validacion de backend-->
                    <span v-if="errors.find( el => el.field == 'dni')" class="ml-2 text-red-500">
                        * {{ errors.find( el => el.field == 'dni').message }}
                    </span>
                </div>

                <!-- input cuil -->
                <div>
                    <label class="text-gray-700" for="title">CUIL</label>

                    <input
                        class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
                        type="text" id="title" name="title"
                        v-model="teacher.profile.cuil">

                    <!-- Validacion de frontend -->
                    <span v-if="v$?.teacher?.profile?.cuil && v$.teacher.profile.cuil.$dirty && v$.teacher.profile.cuil.$error" class="text-sm text-red-500 mt-1">
                        <p v-for="error in v$.teacher.profile.cuil.$errors" :key="error.$uid" class="text-sm text-red-500 mt-1 ml-2">
                            {{ error.$message }}
                        </p>
                    </span>

                    <!-- Validacion de backend-->
                    <span v-if="errors.find( el => el.field == 'cuil')" class="ml-2 text-red-500">
                        * {{ errors.find( el => el.field == 'cuil').message }}
                    </span>
                </div>

                <!-- input password -->
                <!-- <div class="w-full md:w-1/4 mt-2 px-2">
                    <label class="text-gray-700" for="title">Password</label><br>
                    <input
                        class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
                        type="text" id="title" name="title"
                        v-model="teacher.password"
                        :disabled="true">
                </div> -->

                <!-- input address -->
                <div>
                    <label class="text-gray-700" for="title">Direccion</label>
                    <span v-if="errors.find( el => el.field == 'address')" class="ml-2 text-red-500">
                        * {{ errors.find( el => el.field == 'address').message }}
                    </span>

                    <input
                        class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
                        type="text" id="title" name="title"
                        v-model="teacher.profile.address">
                </div>

            <!-- input email -->
            <div>
                    <label class="text-gray-700" for="title">Email</label>

                    <input
                        class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
                        type="text" id="title" name="title"
                        v-model.trim="teacher.email"
                        v-lowercase
                    >

                    <!-- Validacion de frontend -->
                    <span v-if="v$?.teacher?.email && v$.teacher.email.$dirty && v$.teacher.email.$error" class="text-sm text-red-500 mt-1">
                        <p v-for="error in v$.teacher.email.$errors" :key="error.$uid" class="text-sm text-red-500 mt-1 ml-2">
                            {{ error.$message }}
                        </p>
                    </span>

                    <!-- Validacion de backend -->
                    <span v-if="errors.find( el => el.field == 'email')" class="ml-2 text-red-500">
                        * {{ errors.find( el => el.field == 'email').message }}
                    </span>
                </div>

                <!-- input mobile phone -->
                <div>
                    <label class="text-gray-700" for="title">Celular</label>

                    <input
                        class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
                        type="text" id="title" name="title"
                        v-model="teacher.profile.phone">

                    <!-- Validacion de frontend -->
                    <span v-if="v$?.teacher?.profile?.phone && v$.teacher.profile.phone.$dirty && v$.teacher.profile.phone.$error" class="text-sm text-red-500 mt-1">
                        <p v-for="error in v$.teacher.profile.phone.$errors" :key="error.$uid" class="text-sm text-red-500 mt-1 ml-2">
                            {{ error.$message }}
                        </p>
                    </span>
                </div>
            </div>
            </form>
                
            <!-- Buttons    -->
            <div class="flex fmd:flex-row mx-2 my-5 space-x-3">
                <button @click="showConfirmAction" class="px-4 py-2 text-gray-200 bg-gray-800 rounded-md hover:bg-gray-700 focus:outline-none focus:bg-gray-700">
                    Guardar
                </button>
                <button class="px-4 py-2 text-gray-200 bg-gray-500 rounded-md hover:bg-gray-700 focus:outline-none focus:bg-gray-700"
                    @click="goTo('/preceptores')">
                    Cancelar
                </button>
            </div>

        

            <!-- ComponentsConfirAction : Modal de Confirmacion -->
            <ConfirmAction
            :isVisible="isvisibleModal"
            @confirm="saveStudentAssistant"
            @cancel="closeConfirmAction"
            title='¿Quieres guardar el Preceptor?'
            action='Guardar'
            description="Al presionar aceptar,los cambios se guardaran permanentemente"
            :processing="processing"
            />

        
    </template>
</template>

<script>
import { ref } from 'vue'
import lowercase from '@/directives/lowercase.js'
import useVuelidate from '@vuelidate/core'
import { mapGetters } from 'vuex'


import {
   required,
   numeric,
   minLength,
   maxLength,
   email as isEmail
} from '@vuelidate/validators'

import { helpers } from '@vuelidate/validators'


export default {
    name: 'CreateEditStudentAssistant',
    components: {  },
    directives: { lowercase },
    data() {
        return {
            v$: null,
            isLoading: true,
            processing: false,
            errors: [],
            userId: null,
            enrollment: null,
            enrollmentId: null,
            actionCreate: false,
            isvisibleModal: false,
            departments: [
                { id: 1, name: 'Departamento' },
            ],
            provinces: [
                { id: 1, name: 'Provincia' },
            ],
            genders: [
                { id: 'm', name: 'Masculino' },
                { id: 'f', name: 'Femenino' },
                { id: 'n', name: 'No especificar' },
            ],
            teacher: {
                    id: '',
                    email: '',
                    password: '',
                    profile: {
                        kd: '',
                        firstname: '',
                        lastname: '',
                        dni: '',
                        cuil: '',
                        address: '',
                        phone: ''
                    },
                },
            formTeacher: {
                firstname: "",
                lastname: "",
                dni: "",
                cuil: "",
                email: "",
                password: "",
                phone: "",
                address: "",
                enrollment_date: "",
            }
        }
    },
    validations() {
        return {
            teacher: {
                profile: {
                    cuil: {
                        required: helpers.withMessage('El CUIL es obligatorio.', required),
                        numeric: helpers.withMessage('Solo se permiten números.', numeric),
                        minLength: helpers.withMessage('Debe tener al menos 9 dígitos.', minLength(9)),
                        maxLength: helpers.withMessage('Debe tener menos de 12 dígitos.', maxLength(11)),
                    },
                    dni: {
                        required: helpers.withMessage('El DNI es obligatorio.', required),
                        numeric: helpers.withMessage('Solo se permiten números.', numeric),
                        minLength: helpers.withMessage('Debe tener al menos 8 dígitos.', minLength(8)),
                        maxLength: helpers.withMessage('Debe tener maximo 8 dígitos.', maxLength(8)),
                    },
                    firstname: { required: helpers.withMessage('Este dato es obligatorio.', required) },
                    lastname: { required: helpers.withMessage('Este dato es obligatorio.', required)  },
                    phone: { required: helpers.withMessage('Este dato es obligatorio.', required)  },
                },
                email: { required: helpers.withMessage('Este dato es obligatorio.', required), isEmail }
            }
        }
    },
    created(){
        const id = this.$route.params.id;
        if (id && this.currentUser?.role === 'student_assistant') {
            const uid = this.currentUser.user_id ?? this.currentUser.id
            if (uid != null && String(id) !== String(uid)) {
                this.$router.replace({ name: 'PreceptoresView' })
                return
            }
        }
        if(id){
            this.actionCreate = false
            this.isLoading   = true
            this.getStudentAssistant(id)
            this.userId = id
        } else {
            this.actionCreate = true
        }
    },
    mounted() {
        this.v$ = useVuelidate(this.$options.validations.call(this), this)
    },
    computed: {
      ...mapGetters('authentication', ['currentUser'])
    },
    methods: {
        mapAssistantFromApi(raw) {
            const emptyProfile = {
                kd: '',
                firstname: '',
                lastname: '',
                dni: '',
                cuil: '',
                address: '',
                phone: '',
            }
            if (!raw) {
                return { id: '', email: '', password: '', profile: { ...emptyProfile } }
            }
            const p = raw.profile || raw.Profile || {}
            return {
                id: raw.id ?? '',
                email: raw.email ?? '',
                password: raw.password ?? '',
                profile: {
                    kd: p.kd ?? '',
                    firstname: p.firstname ?? '',
                    lastname: p.lastname ?? '',
                    dni: p.dni != null ? String(p.dni) : '',
                    cuil: p.cuil != null ? String(p.cuil) : '',
                    address: p.address ?? '',
                    phone: p.phone ?? '',
                },
            }
        },
        getStudentAssistant(user_id) {
            this.$http.get(`/student-assistants/${user_id}`)
            .then(resp => {
                this.teacher = this.mapAssistantFromApi(resp.data.data)
            })
            .catch(error => console.error(error))
            .finally(() => {
                this.isLoading = false
            })
        },

        //ActionModal
        showConfirmAction(){
            this.isvisibleModal = true
        },

        closeConfirmAction(){
            this.isvisibleModal =false
        },

        goTo(value){
            this.$router.push(`${value}`)
        },
        saveStudentAssistant(){
            this.v$.$touch()
            if (this.v$.$invalid) {
                this.isvisibleModal = false;
                return
            }
            if(this.actionCreate) {
                this.processing = true
                this.$http.post(`/student-assistants`, this.teacher)
                .then( res => {
                    if (res.data.status == 'error'){
                        this.errors =  res.data.data.errors;
                        this.processing = false
                        this.isvisibleModal = false;
                        return
                    }
                    this.isvisibleModal = false;
                    this.$router.push(`/preceptores`)
                })
                .catch(error => {
                    console.log('error', error)
                    this.errors =  error.response.data.errors;
                    if(this.errors) {
                        this.isvisibleModal = false;
                    }
                });
            } else {
                this.$http.put(`/student-assistants/${this.userId}`, this.teacher)
                .then( res => {
                    if (res.data.status == 'error'){
                        this.errors =  res.data.data.errors;
                        this.processing = false
                        this.isvisibleModal = false;
                        return
                    }
                    this.isvisibleModal = false;
                    this.$router.push('/preceptores')
                })
                .catch(error => {
                    console.log('error', error)
                    this.errors =  error.response.data.errors;
                    if(this.errors) {
                        this.isvisibleModal = false;
                    }
                });
            }
        }
    }
}
</script>

